<template>
  <div>
    <b-modal
      ref="modal"
      title="Fechamento de caixa"
      header-class="border-bottom-0"
      size="xs"
      no-close-on-backdrop
    >
      <template v-if="step === 1">
        <end-shift-difference :accountId="account.id" @stored="handleStoreAccountDifference()"/>
      </template>

      <template v-if="step === 2">
        <end-shift-transfer :accountOriginId="this.account.id" @store="handleStoreAccountTranscer()"/>
      </template>

      <template v-if="step === 3">
        <div class="container-fluid">
          <account-resume-list />
        </div>
      </template>

      <error-handler :error="error" />

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Cancelar
        </button>
        <template v-if="step === 1">
          <button
            role="button"
            class="btn btn-success"
            style="margin-left: 5px"
            @click="step = 2"
          >
            <i class="fas fa-arrow-right"></i> Próximo
          </button>
        </template>
        <template v-if="step === 2">
          <button
            role="button"
            class="btn btn-success"
            style="margin-left: 5px"
            @click="step = 3"
          >
            <i class="fas fa-arrow-right"></i> Próximo
          </button>
        </template>
        <template v-if="step === 3">
          <button
            role="button"
            class="btn btn-success"
            style="margin-left: 5px"
            @click="handleStore()"
          >
            <i class="fas fa-check"></i> Fechar caixa
          </button>
        </template>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Form from "../../../mixins/Form.js";
import moment from "moment";
import AccountResumeList from "../sections/AccountResumeList.vue";
import EndShiftDifference from "../sections/EndShiftDifference.vue";
import EndShiftTransfer from "../sections/EndShiftTransfer";

export default {
  components: {
    AccountResumeList,
    EndShiftDifference,
    EndShiftTransfer,
  },

  props: {
    accountResume: {
      default: () => ({
        sumByOrigin: [],
        sumOrderByPaymentMethod: [],
        closingBalance: {
          closingBalance: 0,
        },
        openingBalance: {
          openingBalance: 0,
        },
      }),
    },
  },

  data: () => ({
    form: new Form({
      description: {
        value: "Lançamento de diferença do caixa",
      },

      account_plan_id: {
        value: 87,
      },

      paid_at: {
        value: null,
        default: moment().format("YYYY-MM-DD"),
      },

      type: {
        options: {
          i: "Entrada",
          o: "Saida",
        },
      },

      value: {
        value: 0,
      },

      account_id: {},
    }),

    step: 1,

    account: {},

    shift_id : null,

    error: null,

    transferValue: 0,

    destination_account: null,

    params: {
      account_id: null,
      shift_id: null,
      page: 1,
    },
  }),

  watch: {
 
  },

  methods: {
    async open(account, shift_id) {
      this.$store.commit("showLoading");
      this.shift_id = shift_id
      this.account = account;
      this.form.account_id.value = account.id;
      this.step = 1;
      this.$refs.modal.show();
      await this.getDrawerResume()
      this.$store.commit("hideLoading");
    },


    async handleStore() {
      await this.$store.dispatch("drawer/postEndShift", {
        account_id: this.account.id,
      }),
      await this.$store.dispatch("account/getAccounts");
      this.$emit('update')
      this.$refs.modal.hide();
    },

    async getDrawerResume() {
      let params = {
        account_id : this.account.id,
        shift_id : this.shift_id,
      }

      await this.$store.dispatch("drawer/getDrawerResume", params);
    },

    async handleStoreAccountDifference() {
      await this.getDrawerResume()
      this.step = 2
      this.$emit('update')
    },

    async handleStoreAccountTranscer() {
      await this.getDrawerResume()
      this.step = 3
      this.$emit('update')
    }
  },
};
</script>
